import { ControlledMaskedInput } from './ControlledInputs';
import { LiliMask } from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/index';
import { useTranslation } from 'react-i18next';

interface DateOfBirthInputProps {
  readonly?: boolean;
}

export const DateOfBirthInput = ({ readonly }: DateOfBirthInputProps) => {
  const { t } = useTranslation();

  return (
    <ControlledMaskedInput
      name={OnboardingFormFields.DATE_OF_BIRTH}
      title={t('pages.identity.bdFieldTitle')}
      id={OnboardingFormFields.DATE_OF_BIRTH}
      mask={LiliMask.DATE}
      readonly={readonly}
    />
  );
};
